import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NbButtonModule, NbCardModule, NbInputModule, NbLayoutModule, NbSpinnerModule, NbToastrService } from '@nebular/theme';
import { AuthService } from '../../core/auth/auth.service';

import { mensagemDeErro } from '../../utils/mensagem-erro';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, NbLayoutModule, NbCardModule, NbButtonModule, NbInputModule, NbSpinnerModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  login = '';
  senha = '';
  carregando = false;

  /** O cartão alterna entre entrar e pedir o link de senha nova, sem sair da rota. */
  modo: 'entrar' | 'recuperar' = 'entrar';
  enviandoRecuperacao = false;
  /** Texto que a API devolveu ao aceitar o pedido; enquanto houver, o formulário some. */
  mensagemRecuperacao = '';

  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly toastr = inject(NbToastrService);

  ngOnInit(): void {
    if (this.auth.isAuthenticated()) {
      this.auth.ensurePerfil().subscribe(() => this.irParaDestino('/dashboard'));
    }
  }

  entrar(): void {
    const l = this.login.trim();
    if (!l || !this.senha) {
      this.toastr.warning('Informe login e senha.', 'Atenção');
      return;
    }
    this.carregando = true;
    this.auth.login({ login: l, senha: this.senha }).subscribe({
      next: () => {
        this.carregando = false;
        this.toastr.success('Bem-vindo!', 'DOMUS DATA');
        const ret = this.route.snapshot.queryParams['returnUrl'];
        this.irParaDestino(typeof ret === 'string' ? ret : '/dashboard');
      },
      error: (err) => {
        this.carregando = false;
        const msg = mensagemDeErro(err, 'Não foi possível entrar.');
        this.toastr.danger(msg, 'Login');
      },
    });
  }

  abrirRecuperacao(): void {
    this.modo = 'recuperar';
    this.mensagemRecuperacao = '';
  }

  voltarParaEntrar(): void {
    this.modo = 'entrar';
    this.mensagemRecuperacao = '';
  }

  /**
   * A resposta é a mesma exista ou não o login (a API não revela quem está cadastrado), então
   * a tela mostra o texto dela e não conclui nada por conta própria (`MSG-06`).
   */
  enviarRecuperacao(): void {
    const l = this.login.trim();
    if (!l) {
      this.toastr.warning('Informe seu login.', 'Atenção');
      return;
    }
    this.enviandoRecuperacao = true;
    this.auth.recuperarSenha({ login: l }).subscribe({
      next: (res) => {
        this.enviandoRecuperacao = false;
        this.mensagemRecuperacao =
          res?.mensagem?.trim() || 'Pedido enviado. Confira seu e-mail.';
      },
      error: (err) => {
        this.enviandoRecuperacao = false;
        this.toastr.danger(mensagemDeErro(err, 'Não foi possível pedir a recuperação de senha.'), 'Recuperar senha');
      },
    });
  }

  private irParaDestino(url: string): void {
    if (url.startsWith('/login')) {
      this.router.navigateByUrl('/dashboard');
      return;
    }
    this.router.navigateByUrl(url || '/dashboard');
  }
}
